import React, { Component } from 'react';
import { isEmpty, size } from 'lodash';
import { Box, Button, FormHelperText, Grid, Typography } from '@mui/material';
import Dialog from '../../common/Dialog';
import DemandLineForm from './DemandLineForm';
import { AddCircleOutlineRounded } from '@mui/icons-material';


class DemandsForm extends Component {
    state = { 
        demand_articles: [
            {
                demand_article: "",
                demand_quantity: "",
                demand_remarks: "",
                demand_articleDisplay: {value: "", label: ""}
            }
        ],
        errors: [
            {
                demand_article: "",
                demand_quantity: "",
                // demand_remarks: ""
            }
        ]
        
    }
    componentDidMount = () => {
        console.log('===============DEMANDS=====================');
        console.log(this.props.DEMANDS);
        console.log('====================================');
        if (!isEmpty(this.props.DEMANDS)) {
            let demand_articles = []
            let errors = []
            Object.values(this.props.DEMANDS).map( demand => {
                demand.demand_articleDisplay = {
                    value: demand.demand_article,
                    label: this.props.ARTICLES[demand.demand_article].article_name,
                }
                demand_articles.push(demand)
                errors.push({
                    demand_article: "",
                    demand_quantity: "",
                    // demand_remarks: ""
                })

            })
            this.setState({
                demand_articles,
                errors
            })
        }   

    }

    handleAddForm = () => {
        
        this.setState({
            demand_articles: [
                ...this.state.demand_articles,
                {
                    // demand_id: "", for updates ?
                    demand_article: "",
                    demand_quantity: "",
                    demand_remarks: "",
                    demand_articleDisplay: {value: "", label: ""}
                }
            ],
            
            errors:[
                ...this.state.errors, {
                    demand_article: "",
                    demand_quantity: "",
                    // demand_remarks: ""
                }
            ]
            
        })
    }
    createAddForm = () => {
        const { demand_articles } = this.state
        
        let selected = demand_articles.map( item => item.demand_article)
        console.log('====================================');
        console.log({selected});
        console.log('====================================');
        let tab = []
        let total = 0
        // for(let i = 0; i < size(demand_articles); i++){
            demand_articles.map((art, i) => {
                total += art.demand_quantity
                
                tab.push(
                    <DemandLineForm
                        {...art}
                        ARTICLES={ Object.values(this.props.ARTICLES).filter(
                            art => this.props.SESSION.session_articles.split(", ").includes(
                                art.article_id
                            )
                        )}
                        SESSION={this.props.SESSION}
                        selected={selected}
                        errors={this.state.errors[i]} 
                        handleChange={this.handleChangeArticles} 
                        handleChangeCreatable={this.handleChangeCreatable} 
                        deleteLine={this.deleteLine} 
                        index={i} 
                    />
                )
            })
            
        // }
        return {tab, total}
    }

    deleteLine = (index) => {
        this.setState({
            demand_articles: [
                ...this.state.demand_articles.slice(0,index),
                ...this.state.demand_articles.slice(index +1),
            ],
            errors: [
                ...this.state.errors.slice(0,index),
                ...this.state.errors.slice(index +1),
            ]
            ,
        })

    }
    handleChangeArticles = (name, value, index) => {
        console.log('=========== handleChangeArticles ===============');
        console.log({name, value, index});
        
        let cpArticles = [].concat(this.state.demand_articles)  
        if( name == "demand_quantity" ){
            cpArticles[index][name] = parseFloat(value) 
        } else {
            cpArticles[index][name] = value
        } 

        console.table(cpArticles);

        this.setState({
            ...this.state,
            demand_articles: cpArticles
        })
    }
    handleChangeCreatable = (option, name, index) => {
        let cpArticles = [].concat(this.state.demand_articles) 
        if(option){         
            cpArticles[index][name] = option.value
            cpArticles[index][`${name}Display`] = option
        } else {
            cpArticles[index][name] = ""
            cpArticles[index][`${name}Display`] = {label: "", value: ""}
        }
        this.setState({
            ...this.state,
            demand_articles: cpArticles
        })
    }
    validate = () => {
        let demand_articles = [].concat(this.state.demand_articles)
        let total = size(demand_articles)
        let required = [
            "demand_quantity",
            "demand_article",
        ]

        // let errors = []
        let errors = [].concat(this.state.errors)
        let noError = true

        demand_articles.forEach( (item, index) => {
            required.forEach(field => {
                if( isEmpty(item[field]) && !item[field] ) { 
                    console.log(`${field} is empty`)
                    noError = false
                    errors[index][field] = "Veuillez remplir ce Champ" 
                } else {
                    if(field == "demand_quantity" && item[field] < 1  ){
                        errors[index][field] = " " 

                    } else {
                        errors[index][field] = "" 
                    }
                }
            })
        })
       console.log('===============in validateArticles=====================');
       console.log({errors});
       console.log('====================================');
        // return {
        //     noError, errors, total
        // }
        this.setState({
            errors: errors,
            noError: noError,
            total: total
        })
        return noError
    }

    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            data.demand_articles = this.state.demand_articles
            data.demand_session = this.props.SESSION.session_id

            console.log('====================================');
            console.log("submit demand", {data});
            console.log('====================================');
        
            await this.props.newUserDemand(data)

            // // if NoErrors ...
            if(this.props.STATE.demands.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.demands.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    validateUpdate = () => {
        let noError = true
        let errors = {} 
        let required = [
            "demand_articles",
        ]
            
        console.log('====================================');
        console.log({required});
        console.log('====================================');
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
        return noError
    }
    handleSubmitUpdate = async () => {

        if( this.validateUpdate() ){
            let data = Object.assign({}, this.props.demand)
            data.demand_articles = isEmpty(this.state.demand_articles) ? "" : this.state.demand_articlesID.join(", ")

            console.log('====================================');
            console.log("submit demand", {data});
            console.log('====================================');
        
            await this.props.updateSession(data)
            
            // // if NoErrors ...
            if(this.props.STATE.demands.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.demands.error}`)
            } else { 
                this.props.notif("success", "la demand a été modifiée")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { update, SESSION, ARTICLES } = this.props;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        const { tab, total } = this.createAddForm();
        return (
            <Dialog
                title={`Ma liste de Demandes`}
                close={this.props.handleClose}
                submitAction={!isEmpty(tab) && this.handleSubmit}
                appBar
                maxWidth="md"
            >
                <Grid container >
                    <Grid item xs={12}>
                        {tab}
                    </Grid>
                </Grid>      
                {size(tab) < size(ARTICLES) &&
                    <Box style={{textAlign: "center"}}>
                        <Button startIcon={<AddCircleOutlineRounded />} variant="contained" onClick={this.handleAddForm} color="secondary">
                            Ajouter un Article
                        </Button>
                    </Box>
                }
            </Dialog>
        );
    }
}

export default DemandsForm;